interface AppBarProps {
  onWhistle: () => void;
  onUpgrade: () => void;
}

export function AppBar({ onWhistle, onUpgrade }: AppBarProps) {
  return (
    <header className="app-bar">
      <button
        type="button"
        className="btn-upgrade"
        onClick={onUpgrade}
        aria-label="会员与用量"
      >
        免费版
      </button>
      <h1>PawAI</h1>
      <button
        type="button"
        className="btn-whistle"
        onClick={onWhistle}
        aria-label="叫 TA 看镜头"
      >
        🔔
      </button>
    </header>
  );
}
